import React from 'react';
const SvgImage = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <path fill="#5C7896" d="M3 1v30h26V8h-7V1H3z" />
      <path opacity={0.3} fill="#1B3F63" d="M29 15l-7-7h7v7z" />
      <path fill="#769CC2" d="M22 1l7 7h-7V1z" />
      <g>
        <path
          fill="#FFF"
          d="M9 10h14v11H9V10zM8 9v15h16V9H8zm11 4.5c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5-.7-1.5-1.5-1.5-1.5.7-1.5 1.5zM10 20h10l-6-6-4 4v2z"
        />
      </g>
    </svg>
  );
});
export default SvgImage;
SvgImage.iconName = 'image';
SvgImage.displayName = 'SvgImage';
